import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { DateRangeRequiredValidator } from "../../../util/components/date-range-picker/date-range-required.validator";
import { DateTime } from "luxon";

@Component({
    selector: "app-timeframe-modal",
    templateUrl: "./timeframe-modal.component.html",
    styleUrl: "./timeframe-modal.component.scss",
    standalone: false
})
export class TimeframeModalComponent implements OnInit {
  form: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    public modal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    const now = DateTime.now();
    const firstDayOfYear = now.startOf("year").toJSDate();
    const lastDayOfYear = now.endOf("year").toJSDate();
    this.form = this.formBuilder.group({
      range: [{ from: firstDayOfYear, to: lastDayOfYear }, DateRangeRequiredValidator],
    });
  }
}
